export default {
  txt: '恭喜您，您的入驻申请已审核通过',
  shopName: '店铺名',
  shopType: '店铺级别',
  date: '开通时间',
  loginNow: '立即登录'
}
